import { UgcTab } from "../typings";

export const taskText = [
  {
    key: "dailyLogin",
    title: "每日首次登入",
    descript: "每日登入頁面（5分）",
    login: true,
  },
  {
    key: "advanceReservation",
    title: "前往預約遊戲",
    descript: "首次完成遊戲預約（25分）",
    callbackKey: 5,
    redirectUrl: `https://roworld.gnjoy.hk/mlktgayy/`,
  },
  {
    key: "provideFeedback",
    title: "提交意見反饋",
    descript: "每日首次提交反饋（15分）",
    feedbackPopup: true,
  },
  {
    key: "submitRoMemory",
    title: "我的RO回憶投稿",
    descript: "每日首次投稿（15-25分），每週上限50分",
    ugcTab: UgcTab.UgcTypeMyROMemory,
    autoOpen: true,
  },
  {
    key: "submitCostumeDesign",
    title: "時裝設計投稿",
    descript: "每日首次投稿（25分），每週上限25分",
    ugcTab: UgcTab.UgcTypeCostume,
    autoOpen: true,
  },
  {
    key: "submitPhoto",
    title: "美照分享投稿",
    descript: "每日首次投稿（25分），每週上限50分",
    ugcTab: UgcTab.UgcTypePhoto,
    autoOpen: true,
  },
  {
    key: "likeOthersUgc",
    title: "為他人作品按讚",
    descript: "每次按讚可獲得0.5分，每日上限5分（{n}/5分）",
    ugcTab: UgcTab.UgcTypeMyROMemory,
  },
  {
    key: "likeMyUgc",
    title: "作品獲得讚",
    descript: "獲得1個讚可得1分，每週上限200分（{n}/200分）",
    centerTab: true,
  },
  {
    key: "joinFb",
    title: "追蹤Facebook",
    descript: "加入官方Facebook（10分）",
    callbackKey: 1,
    redirectUrl: `https://www.facebook.com/ROWorld.Gravity/`,
  },
  {
    key: "joinDc",
    title: "追蹤Discord",
    descript: "關注官方Discord（10分）",
    callbackKey: 2,
    redirectUrl: `https://discord.com/invite/GhKGR6cTBm`,
  },
  {
    key: "joinYtb",
    title: "追蹤YouTube",
    descript: "追蹤官方YouTube（10分）",
    callbackKey: 4,
    redirectUrl: `https://www.youtube.com/@RagnarokWorld`,
  },
  {
    key: "joinLine",
    title: "追蹤LINE",
    descript: "追蹤官方LINE（10分）",
    callbackKey: 3,
    redirectUrl: `https://line.me/ti/g2/7iImQvsdg0eDdYNfLuOST_iRSo3mP66qWUaAKA?utm_source=invitation&utm_medium=link_copy&utm_campaign=default`,
  },
];

export const awardConfig = {
  Thanks: "謝謝參與",
  Title: "稱號",
  Avatar: "頭像框",
  PhoneHolder: "巴風特手機支架",
  CanvasBag: "大世界帆布包",
  FridgeMagnet: "初心者裝死冰箱貼",
  Calendar: "波利萬年曆",
  WaistPillow: "RO職業書本腰靠",
  Headwear: "頭飾",
  ScoreTitleLv1: "稱號：初心者腦洞好大喔",
  ScoreTitleLv2: "稱號：RO大世界入股不虧",
  ScoreTitleLv3: "稱號：不裝了我是創世神",
};
